import { render } from "./CustomTable.vue?vue&type=template&id=8af62a6e&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=8af62a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af62a6e"]])

export default __exports__